import React from 'react';
import { GroupLabel } from 'components/MenuList';
export default function ComboBoxMenuGroupLabel(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(GroupLabel, {
    as: "li"
  }, children);
}